<template>
    <div>
        <v-row class="mx-0">
            <v-col v-if="showCharts.TicketFrequency" cols="12">
                <div class="helpical-cards">
                    <p class="text-meta text-primary font-weight-medium"><v-icon class="me-2" color="secondary" size="20">icon-analytics</v-icon>گزارش ها</p>
                    <p class="text-small text-grey-darken-1 my-2">با هدف آگاهی از عملکردهای فردی یا سازمانی، ابزار گزارش ساز هلپیکال داده های اطلاعاتی سامانه را از طریق نمودارهای گرافیکی در اختیار شما قرار می دهد.<br>برای تولید گزارش‌های دقیق‌تر می توانید از فیلترهای پیشرفته استفاده نمائید.</p>
                    <v-row align="center" justify="center" class="mx-0">
                        <v-col lg="2" sm="3" cols="12" v-if="$auth.user.full_admin">
                            <v-select
                                :items="branchList"
                                clearable
                                item-title="name"
                                item-value="id"
                                no-data-text="موردی پیدا نشد!"
                                hide-details
                                label="انتخاب شعبه"
                                v-model="search.branch_id"
                            ></v-select>
                        </v-col>
                        <v-col lg="2" sm="3" cols="5">
                            <datetime-input
                                :jumpMinute="5"
                                :roundMinute="true"
                                type="datetime"
                                hide-details
                                clearable
                                v-model="search.from_date"
                                @update:modelValue="(value) => search.to_date = value > search.to_date ? null : search.to_date"
                            ></datetime-input>
                        </v-col>
                        <v-col cols="2" sm="auto">
                            <div class="rounded bg-secondary text-center text-white py-1 px-3 text-small">تا</div>
                        </v-col>
                        <v-col lg="2" sm="3" cols="5">
                            <datetime-input
                                :min="search.from_date"
                                :jumpMinute="5"
                                :roundMinute="true"
                                type="datetime"
                                hide-details
                                clearable
                                v-model="search.to_date"
                            ></datetime-input>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center" class="mx-0">
                        <v-col lg="2" md="3" sm="4" cols="6" v-if="$auth.user.employee">
                            <v-select
                                :items="organizationList"
                                hide-details
                                clearable
                                item-title="name"
                                item-value="id"
                                label="سازمان فرستنده"
                                multiple
                                no-data-text="موردی پیدا نشد!"
                                v-model="search.from_organizations"
                            >
                                <template #selection="data">
                                    <span>{{data.index == 0 ? `${search.from_organizations.length} مورد` : ''}}</span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="6">
                            <v-select
                                :items="departmentList"
                                hide-details
                                clearable
                                item-title="name"
                                item-value="id"
                                label="دپارتمان فرستنده"
                                multiple
                                no-data-text="موردی پیدا نشد!"
                                v-model="search.from_departments"
                            >
                                <template #selection="data">
                                    <span>{{data.index == 0 ? `${search.from_departments.length} مورد` : ''}}</span>
                                </template>
                            </v-select>
                        </v-col>
                            <v-col lg="2" md="3" sm="4" cols="6" v-if="$auth.user.employee">
                            <v-select
                                :items="organizationList"
                                hide-details
                                clearable
                                item-title="name"
                                item-value="id"
                                label="سازمان گیرنده"
                                multiple
                                no-data-text="موردی پیدا نشد!"
                                v-model="search.to_organizations"
                            >
                                <template #selection="data">
                                    <span>{{data.index == 0 ? `${search.to_organizations.length} مورد` : ''}}</span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="6">
                            <v-select
                                :items="departmentList"
                                hide-details
                                clearable
                                item-title="name"
                                item-value="id"
                                label="دپارتمان گیرنده"
                                multiple
                                no-data-text="موردی پیدا نشد!"
                                v-model="search.to_departments"
                            >
                                <template #selection="data">
                                    <span>{{data.index == 0 ? `${search.to_departments.length} مورد` : ''}}</span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col class="py-0 d-md-block d-none" cols="12"></v-col>
                        <v-col lg="2" md="3" sm="4" cols="6">
                            <v-select
                                :items="ticketStatusList"
                                hide-details
                                clearable
                                item-title="name"
                                item-value="id"
                                label="وضعیت تیکت"
                                multiple
                                no-data-text="موردی پیدا نشد!"
                                v-model="search.ticket_statuses"
                            >
                                <template #selection="data">
                                    <span>{{data.index == 0 ? `${search.ticket_statuses.length} مورد` : ''}}</span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="6">
                            <v-select
                                :items="importanceList"
                                hide-details
                                clearable
                                item-title="name"
                                item-value="id"
                                label="درجه اهمیت تیکت"
                                multiple
                                no-data-text="موردی پیدا نشد!"
                                v-model="search.importances"
                            >
                                <template #selection="data">
                                    <span>{{data.index == 0 ? `${search.importances.length} مورد` : ''}}</span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="6">
                            <v-select
                                :items="ticketCategoryList"
                                hide-details
                                clearable
                                item-title="name"
                                item-value="id"
                                label="دسته‌بندی موضوعی"
                                multiple
                                no-data-text="موردی پیدا نشد!"
                                v-model="search.ticket_categories"
                            >
                                <template #selection="data">
                                    <span>{{data.index == 0 ? `${search.ticket_categories.length} مورد` : ''}}</span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="6" v-if="$auth.user.employee">
                            <v-select
                                :items="serviceList"
                                hide-details
                                clearable
                                item-title="name"
                                item-value="id"
                                label="سرویس‌ها/محصولات"
                                multiple
                                no-data-text="موردی پیدا نشد!"
                                v-model="search.services"
                            >
                                <template #selection="data">
                                    <span>{{data.index == 0 ? `${search.services.length} مورد` : ''}}</span>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    <div class="text-center mt-5">
                        <v-btn @click="filterCharts(false)" class="mx-sm-2 mx-1" color="success">نمایش گزارش ها</v-btn>
                        <v-btn @click="filterCharts(true)" class="mx-sm-2 mx-1 rounded" color="secondary" variant="tonal" icon="refresh"></v-btn>
                    </div>
                </div>
            </v-col>
            <v-col v-if="showCharts.TicketFrequency" cols="12">
                <div class="helpical-cards">
                    <report-ticket-frequency ref="reportTicketFrequency"></report-ticket-frequency>
                </div>
            </v-col>
            <v-col v-if="showCharts.TicketCategory" cols="12">
                <div class="helpical-cards">
                    <report-ticket-category ref="reportTicketCategory"></report-ticket-category>
                </div>
            </v-col>
            <v-col v-if="showCharts.TagUserTicket" cols="12">
                <div class="helpical-cards">
                    <report-tag-user-ticket ref="reportTagUserTicket"></report-tag-user-ticket>
                </div>
            </v-col>
            <v-col v-if="showCharts.SatisfactionEmployee" cols="12">
                <div class="helpical-cards">
                    <report-satisfaction-employee ref="reportSatisfactionEmployee"></report-satisfaction-employee>
                </div>
            </v-col>
            <v-col v-if="!highAdminUser && showCharts.ServiceTicket && (showCharts.SlaTicket || $vuetify.display.mdAndDown)" cols="12">
                <div class="helpical-cards">
                    <report-service-ticket ref="reportServiceTicket"></report-service-ticket>
                </div>
            </v-col>
            <v-col v-if="showCharts.TicketStatus" :md="!showCharts.ServiceUser && (!$auth.user.employee || showCharts.ServiceTicket || showCharts.SlaTicket) ? 6 : 4" cols="12">
                <div class="helpical-cards">
                    <report-ticket-status ref="reportTicketStatus"></report-ticket-status>
                </div>
            </v-col>
            <v-col v-if="highAdminUser && showCharts.ServiceTicket" md="8" cols="12">
                <div class="helpical-cards">
                    <report-service-ticket ref="reportServiceTicket"></report-service-ticket>
                </div>
            </v-col>
            <v-col v-if="showCharts.ServiceUser" md="8" cols="12">
                <div class="helpical-cards">
                    <report-service-user ref="reportServiceUser"></report-service-user>
                </div>
            </v-col>
            <v-col v-if="showCharts.ImportanceTicket" :md="!showCharts.ServiceUser && (!$auth.user.employee || showCharts.ServiceTicket || showCharts.SlaTicket) ? 6 : 4" cols="12">
                <div class="helpical-cards">
                    <report-importance-ticket ref="reportImportanceTicket"></report-importance-ticket>
                </div>
            </v-col>
            <v-col v-if="showCharts.SatisfactionTicket" md="4" cols="12">
                <div class="helpical-cards">
                    <report-satisfaction-ticket ref="reportSatisfactionTicket"></report-satisfaction-ticket>
                </div>
            </v-col>
            <v-col v-if="showCharts.SlaTicket" md="8" cols="12">
                <div class="helpical-cards">
                    <report-sla-ticket ref="reportSlaTicket"></report-sla-ticket>
                </div>
            </v-col>
            <v-col v-if="!highAdminUser && showCharts.ServiceTicket && !showCharts.SlaTicket && $vuetify.display.mdAndUp" cols="8">
                <div class="helpical-cards">
                    <report-service-ticket ref="reportServiceTicket"></report-service-ticket>
                </div>
            </v-col>
            <v-col v-if="showCharts.TicketState" :md="highAdminUser && !showCharts.SlaTicket" cols="12">
                <div class="helpical-cards">
                    <report-ticket-state ref="reportTicketState"></report-ticket-state>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    title: "گزارشات",
    data() {
        return {
            branchList: [],
            organizationList: [],
            importanceList: [],
            serviceList: [],
            ticketCategoryList: [],
            ticketStatusList: [],
            departmentList: [],
            search: {
                branch_id: null,
                from_date: null,
                to_date: null,
                ticket_categories: [],
                importances: [],
                services: [],
                ticket_statuses: [],
                from_departments: [],
                to_departments: [],
                from_organizations: [],
                to_organizations: [],
            },
            highAdminUser: this.$auth.user.full_admin || this.$auth.user.branch_admin,
            showCharts: {
                TicketFrequency: true,
                TicketCategory: true,
                ImportanceTicket: true,
                TicketStatus: true,
                SlaTicket: this.$auth.user.employee && this.$system.license.features.ticket_sla,
                TagUserTicket: this.$auth.user.employee,
                SatisfactionTicket: this.$auth.user.employee,
                SatisfactionEmployee: (this.$auth.user.full_admin || this.$auth.user.branch_admin || this.$auth.user.department_admin) && this.$system.license.features.satisfaction_reply,
                ServiceTicket: this.$auth.user.full_admin || this.$auth.user.branch_admin || this.$auth.user.department_admin,
                ServiceUser: this.$auth.user.full_admin || this.$auth.user.branch_admin,
                TicketState: this.$auth.user.full_admin || this.$auth.user.branch_admin,
            }
        };
    },
    methods: {
        filterCharts(refresh = false) {
            if(refresh)
                for (const key in this.search) {
                    if(key != 'from_date' && key != 'to_date' && key != 'branch_id') this.search[key] = [];
                    else this.search[key] = null;
                }
            let searchItems = { ...this.search };
            for (const key in searchItems) {
                if (!searchItems[key]) delete searchItems[key];
            }
            Object.keys(this.showCharts).forEach((el) => {
                if(this.showCharts[el] && el !== 'SatisfactionEmployee' && el !== 'ServiceUser')
                    this.$refs['report' + el][`report${el}Filter`](searchItems);
            });
        },
    },
    mounted() {
        if (this.$auth.user.full_admin)
            this.branchList = this.$system.branches;
        this.importanceList = this.$system.importances;
        this.ticketCategoryList = this.$system.ticketCategories;
        if (this.$auth.user.employee) {
            this.organizationList = this.$system.organizations;
            this.serviceList = this.$system.services;
            this.departmentList = this.$system.departments;
        } else
            this.departmentList = this.$auth.user.to_departments;
        this.ticketStatusList = this.$system.ticketStatuses;

    },
};
</script>
